import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";

const who = (a) => a ? `${a.name || "Unnamed"} (${a.user_id})` : "—";

const MOVED_LABEL = {
  "credential_documents.user_id": ["document", "documents"],
  "credential_documents": ["document", "documents"],
  "applications.professional_id": ["application", "applications"],
  "shifts.facility_id": ["shift", "shifts"],
  "payments.facility_id": ["payment (as hospital)", "payments (as hospital)"],
  "payments.professional_id": ["payment", "payments"],
  "ratings.rater_id": ["rating given", "ratings given"],
  "ratings.ratee_id": ["rating received", "ratings received"],
  "cover_templates.user_id": ["cover template", "cover templates"],
  "notifications.user_id": ["notification", "notifications"],
  "data_deletion_requests.user_id": ["deletion request", "deletion requests"],
  "whatsapp_sessions.data.user_id": ["WhatsApp conversation", "WhatsApp conversations"],
  "sessions.user_id": ["sign-in session", "sign-in sessions"],
  "whatsapp_link": ["WhatsApp link", "WhatsApp link"],
};

export const describeMoved = (moved) => Object.entries(moved || {})
  .map(([k, n]) => { const [one, many] = MOVED_LABEL[k] || [k, k]; return `${n} ${n === 1 ? one : many}`; })
  .join(" · ");

function Moved({ moved }) {
  const text = describeMoved(moved);
  return text ? <span>Moved: {text}</span> : <span className="text-slate-500">Nothing moved</span>;
}

export function AccountHistory({ refreshKey }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/admin/account-history").then(r => setItems(r.data))
      .catch(err => toast.error(err.response?.data?.detail || "Failed to load history"));
  }, [refreshKey]);
  return (
    <section data-testid="history-section">
      <h3 className="font-display text-lg font-semibold mb-3">Merge & repair history</h3>
      {items === null ? null : !items.length ? (
        <div className="text-sm text-slate-500 border border-dashed border-slate-300 rounded-2xl p-6 text-center" data-testid="history-empty">No merges or repairs yet.</div>
      ) : (
        <div className="space-y-3">
          {items.map((h, i) => (
            <Card key={i} className="p-4 rounded-2xl border-slate-200 bg-white text-sm" data-testid={`history-item-${i}`}>
              <div className="flex flex-wrap items-center gap-2">
                <Badge className={h.type === "merge" ? "bg-sky-100 text-sky-800 hover:bg-sky-100" : "bg-amber-100 text-amber-800 hover:bg-amber-100"}>{h.type}</Badge>
                <span className="text-slate-500 text-xs">{new Date(h.at).toLocaleString("en-IN")} · by {h.by || "unknown"}</span>
              </div>
              {h.type === "merge" ? (
                <div className="mt-2 text-slate-700">Merged {who(h.merged)} into {who(h.kept)}</div>
              ) : (
                <div className="mt-2 text-slate-700">Split WhatsApp sign-up from {who(h.admin)} into new account {who(h.new_account)}</div>
              )}
              <div className="mt-1 text-xs text-slate-600" data-testid={`history-moved-${i}`}><Moved moved={h.moved} /></div>
            </Card>
          ))}
        </div>
      )}
    </section>
  );
}
